// import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import rootReducer from './reducers';
import { useDispatch, useSelector } from 'react-redux';
// export const store = configureStore({
//   reducer: rootReducer,
//   middleware: (getDefaultMiddleware) => getDefaultMiddleware()
// });
// export type RootState = ReturnType<typeof rootReducer>;
// export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
